<template>
    <ValidationProvider
        :vid="vid"
        :name="$attrs.label"
        :rules="rules"
        :immediate="true"
        v-slot="{ errors, valid, dirty, touched }"
    >
        <b-field
            v-bind="$attrs"
            :class="{ 'hide-status-icon': (isRequired ? !(dirty || touched) : !(dirty || touched && !!innerValue && innerValue.length)) }"
            :type="{
                'is-danger': isRequired && !valid,
                'is-success': isRequired ? (valid && (dirty || touched)) : true
            }"
            :message="isRequired && (dirty || touched) ? errors : []"
            :status-icon="!(isRequired ? !(dirty || touched) : !(dirty || touched && !!innerValue && innerValue.length))"
        >
            <template slot="label">
                <span v-if="isRequired" class="has-text-danger">*</span>
                {{ $attrs.label }}
            </template>
            <div class="field">
                <div :class="['columns', 'is-multiline']">
                    <div 
                        v-for="(opt, idx) in options" 
                        :key="idx"
                        :class="['column', columnClass]"
                    >
                        <b-checkbox
                            v-model="innerValue"
                            :native-value="opt.value"
                        >
                            {{ opt.label }}
                        </b-checkbox>
                    </div>
                </div>
            </div>
        </b-field>
    </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
    components: {
        ValidationProvider,
    },
    props: {
        vid: {
            type: String,
        },
        rules: {
            type: [Object, String],
            default: '',
        },
        value: {
            type: Array,
            default: () => [],
        },
        options: {
            type: Array,
            required: true, // [{ value, label }]
        },
        columns: {
            type: [String, Number],
            default: 1,
        },
    },
    data: () => ({
        innerValue: [],
    }),
    computed: {
        isRequired() {
            if (!this.rules) return false;
            if (typeof this.rules === 'string') return this.rules.includes('required');
            if (typeof this.rules === 'object') return !!this.rules.required;
            return false;
        },
        columnClass() {
            const cols = parseInt(this.columns);
            if (cols === 1) return 'is-12';
            if (cols === 2) return 'is-6';
            if (cols === 3) return 'is-4';
            if (cols === 4) return 'is-3';
            return 'is-12';
        },
    },
    watch: {
        innerValue(newVal) {
            this.$emit('input', newVal);
        },
        value(newVal) {
            this.innerValue = Array.isArray(newVal) ? newVal : [];
        },
    },
    created() {
        this.innerValue = Array.isArray(this.value) ? this.value : [];
    },
};
</script>

<style scoped>
.hide-status-icon >>> .icon.is-right { display: none !important; }
.m-b-5 { margin-bottom: 0.5rem; }

/* Enhanced validation styling for checkbox groups */
.field.is-danger .columns {
    border: 1px solid #ff3860;
    border-radius: 4px;
    padding: 0.75rem;
    background-color: #fff5f5;
}

.field.is-success .columns {
    border: 1px solid #48c774;
    border-radius: 4px;
    padding: 0.75rem;
    background-color: #f5fff5;
}

/* Required asterisk styling */
.has-text-danger {
    font-weight: bold;
    margin-right: 0.25rem;
}
</style>


